export default __webpack_public_path__ + "static/media/fire.460e3e58.svg";